"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Evaluator_1 = require("../../../../utils/Evaluator");
const utils_1 = require("../../../../utils/utils");
exports.default = [
    {
        key: 'labelPosition',
        ignore: true
    },
    {
        key: 'placeholder',
        ignore: true
    },
    {
        key: 'description',
        ignore: true
    },
    {
        key: 'hideLabel',
        ignore: false
    },
    {
        key: 'autofocus',
        ignore: true
    },
    {
        key: 'tooltip',
        ignore: true
    },
    {
        key: 'tabindex',
        ignore: true
    },
    {
        key: 'disabled',
        ignore: true
    },
    {
        type: 'textarea',
        label: 'Template',
        key: 'templatesComfirm',
        rows: 5,
        editor: 'ace',
        as: 'handlebars',
        clearOnHide: false,
        weight: 201,
        input: true,
        placeholder: '/*** Lodash Template Code ***/',
        tooltip: 'This is the <a href=\'https://lodash.com/docs/4.17.5#template\'>Lodash Template</a> used to render each row ',
        customConditional({ data }) {
            return (!Evaluator_1.Evaluator.noeval || Evaluator_1.Evaluator.protectedEval) && !data.displayAsTable;
        },
    },
    {
        type: 'select',
        input: true,
        weight: 202,
        label: 'List Component to get values from',
        key: 'listComponentKey',
        dataSrc: 'custom',
        valueProperty: 'value',
        multiple: true,
        data: {
            custom(context) {
                const list = (0, utils_1.getContextComponents)(context, null, ['button']);
                context.data.myOptions = list;
                return list;
            }
        },
        calculateValue: `
      if (!data._initialized && data.myOptions) {
        data._initialized = true;
        value = data.myOptions.map(i => i.value);
      }
      if (value && Array.isArray(value) && data.myOptions) {
        const order = data.myOptions.map(i => i.value);
        value = value.slice().sort((a, b) => {
          return order.indexOf(a) - order.indexOf(b);
        });
      }
    `
    },
    {
        type: 'textarea',
        label: 'Formatted Data',
        key: 'formattedDataTemplate',
        rows: 5,
        editor: 'ace',
        as: 'handlebars',
        clearOnHide: false,
        weight: 203,
        input: true,
        customConditional({ data }) {
            return (!Evaluator_1.Evaluator.noeval || Evaluator_1.Evaluator.protectedEval) && !data.displayAsTable;
        },
    },
    {
        type: 'select',
        input: true,
        weight: 204,
        label: 'Confirm type',
        key: 'comfirmType',
        dataSrc: 'values',
        defaultValue: 'default',
        data: {
            values: [
                { label: 'Default', value: 'default' },
                { label: 'Close All', value: 'closeAll' },
                { label: 'Always open', value: 'alwaysOpen' },
            ],
        },
    },
    {
        weight: 500,
        type: 'textfield',
        input: true,
        key: 'theme',
        label: 'Item Theme',
        placeholder: 'Item CSS Class',
        tooltip: 'The color theme of buttons.',
    },
    {
        weight: 500,
        type: 'textfield',
        input: true,
        key: 'themeActive',
        label: 'Active Item Theme',
        placeholder: 'Item CSS Class',
        tooltip: 'The color theme of Active button.',
    },
];
